import { render, staticRenderFns } from "./UpdateCenterCategoryPage.vue?vue&type=template&id=5e7daa76&scoped=true"
import script from "./UpdateCenterCategoryPage.vue?vue&type=script&lang=js"
export * from "./UpdateCenterCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7daa76",
  null
  
)

export default component.exports